import { showError } from "./ErrorPopup";
import React, { useState } from 'react';
import { apiFetch } from '../utils/apiClient';

const FichierExcelRh = ({ nomformulaire, startDate, endDate }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true); // 🔥 start spinner

      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/downloadExcelRh`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            nomformulaire,
            startDate,
            endDate,
          }),
        }
      );

      if (!response.ok) {
        let message = "Erreur lors de la génération du fichier Excel.";

        try {
          const result = await response.json();
          message = result.error || result.message || message;
        } catch {
          // La réponse d'erreur n'est pas nécessairement au format JSON.
        }

        throw new Error(message);
      }

      const blob = await response.blob();

      const disposition = response.headers.get('Content-Disposition');
      let filename = 'Export.xlsx';

      if (disposition) {
        const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        const fallbackMatch = disposition.match(/filename="?([^";]+)"?/i);

        if (utf8Match?.[1]) {
          try {
            filename = decodeURIComponent(utf8Match[1]);
          } catch {
            filename = utf8Match[1];
          }
        } else if (fallbackMatch?.[1]) {
          filename = fallbackMatch[1];
        }
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error(error);
      showError(error); // ou setError(error.message)
    } finally {
      setLoading(false); // 🔥 stop spinner
    }
  };

  const isDisabled =
    (nomformulaire === "AEFO" ||
      nomformulaire === "FEESO" ||
      nomformulaire === "SCFP" ||
      nomformulaire === "rapport de police") &&
    (!startDate || !endDate);

  return (
    <div>
      <button
        onClick={handleDownload}
        disabled={isDisabled || loading}
        className={`text-sm px-6 py-2 font-semibold rounded-lg shadow-md transition duration-200
        ${
          isDisabled || loading
            ? "bg-gray-400 text-gray-200 cursor-not-allowed"
            : "bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
        }`}
      >
        {loading ? (
          <span className="flex items-center gap-2">
            <svg
              className="animate-spin h-4 w-4 text-white"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              />
            </svg>
            Téléchargement...
          </span>
        ) : (
          `Télécharger le fichier Excel ${nomformulaire}`
        )}
      </button>
    </div>
  );
};

export default FichierExcelRh;


// import React from 'react'
// import { apiFetch } from '../utils/apiClient'; // ✅ import your reusable fetch hel

// const FichierExcelRh = ({nomformulaire, startDate, endDate}) => {
//       const handleDownload = async () => {
//   try {
//     const response = await apiFetch(
//         `${process.env.REACT_APP_API_BASE_URL}/downloadExcelRh`,
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             nomformulaire,
//             startDate,
//             endDate,
//           }),
//         }
//       );
//     if (response.ok) {
//       const blob = await response.blob();

//       // Try to extract filename from Content-Disposition header
//       const disposition = response.headers.get('Content-Disposition');
//       let filename = 'Export.xlsx';

//       if (disposition) {
//   const match = disposition.match(/filename="?([^"]+)"?/);
//   if (match && match[1]) {
//     filename = match[1];
//   }
// }

//       // Trigger the download
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } else {
//       console.error('Erreur lors du téléchargement du fichier');
//     }
//   } catch (err) {
//     console.error('Erreur lors de la requête de téléchargement', err);
//   }
// };
//       return (
//         <div>
//           <button
//   onClick={handleDownload}
//   disabled={(nomformulaire === "AEFO" || nomformulaire === "FEESO" || nomformulaire === "SCFP" || nomformulaire === "rapport de police")&& (!startDate || !endDate)}
//   className={`text-sm px-6 py-2 font-semibold rounded-lg shadow-md transition duration-200
//     ${ (nomformulaire === "AEFO" || nomformulaire === "FEESO" || nomformulaire === "SCFP" || nomformulaire === "rapport de police") && (!startDate || !endDate)
//       ? "bg-gray-400 text-gray-200 cursor-not-allowed"
//       : "bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
//     }`}
// >
//             Télécharger le fichier Excel {nomformulaire} 
//           </button>
//         </div>
//       );
// }

// export default FichierExcelRh
